import i18next from 'i18next';
import common from '../common';
import Text from '../ui/Text';
import Scene from './Scene';
import ScenarioCarousel from './gui/ScenarioCarousel';
import ScenarioDifficultySelect from './gui/ScenarioDifficultySelect';
import SplashGlobe from '../SplashGlobe';

export default class SelectScenarioScene extends Scene {
	constructor() {
		super();

		this._background = null;
		this._earth = null;
		this._overlay = null;
		this._bgContainer = null;
		this._headerBg = null;
		this._headerLabel = null;
		this._headerUnderline = null;
		this._carousel = null;
		this._difficultySelect = null;
		this._backButton = null;

		this._selectedScenario = null;
		this._selectedDifficulty = null;
		this._stage = SelectScenarioScene.STAGE.SCENARIO;
	}

	init() {
		super.init();

		const blur = new PIXI.filters.BlurFilter();

		blur.strength = 1;

		this._bgContainer = new PIXI.Container();
		this.addChild(this._bgContainer);

		this._background = new PIXI.Sprite(P3.assets.texture('splash_bg'));

		this._background.anchor.set(0.5);
		this._background.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._background.width = common.STAGE_WIDTH;
		this._background.height = P3.View.height;
		this._bgContainer.addChild(this._background);

		this._earth = new SplashGlobe();
		common.tCamera.position.set(0, 0, 2);
		common.tScene.add(this._earth);

		this._earthSprite = new PIXI.Sprite(PIXI.Texture.from($('#three-canvas')[0]));
		this._earthSprite.anchor.set(0.5);
		this._earthSprite.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 300);
		this._bgContainer.addChild(this._earthSprite);

		this._overlay = new PIXI.Sprite(P3.assets.texture('overlay_full'));

		this._overlay.anchor.set(0.5);
		this._overlay.width = this._earthSprite.width + 100;
		this._overlay.scale.y = this._overlay.scale.x;
		this._overlay.position.set(this._earthSprite.position.x, this._earthSprite.position.y);
		this._bgContainer.addChild(this._overlay);

		this._bgContainer.filters = [blur];

		this._headerBg = new PIXI.Graphics();
		this._headerBg.beginFill(0x0, 1);
		this._headerBg.drawRect(0, 0, P3.View.width, 50);
		this._headerBg.endFill();
		this.addChild(this._headerBg);

		this._headerLabel = new Text('gui.selectscenario.select', { font: '32px', align: 'center', tint: 0xFFFFFF });

		this._headerLabel.anchor.set(0.5);
		this._headerLabel.position.set(common.STAGE_WIDTH * 0.5, 25);
		this.addChild(this._headerLabel);

		this._headerUnderline = new PIXI.Graphics();
		this._headerUnderline.beginFill(0x202C45, 1);
		this._headerUnderline.drawRect(0, 0, P3.View.width, 2);
		this._headerUnderline.endFill();
		this._headerUnderline.position.set(0, 50);
		this.addChild(this._headerUnderline);

		this._carousel = new ScenarioCarousel();
		this._carousel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._carousel.signals.selected.add(this.onCarouselSelected, this);
		this.addChild(this._carousel);

		const states = new P3.ButtonStates();

		states.normal = P3.assets.texture('btn_blue_fill_medium_9slice_out');
		states.over = P3.assets.texture('btn_blue_fill_medium_9slice_over');
		states.icon = P3.assets.texture('icon_arrow_r');

		this._backButton = common.buttonFactory.createButton(states);
		this._backButton.overSoundName = 'sfx_genericrollover';
		this._backButton.clickSoundName = 'sfx_genericclick';
		this._backButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 60, 100);
		this._backButton.scale.x = -1;
		this._backButton.signals.click.add(this.onBackClick, this);

		this._backButton.accessibleTitle = i18next.t('accessibility.button.back');
		this._backButton.tabIndex = 4;

		this.addChild(this._backButton);
	}

	resize() {
		super.resize();
		this._background.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._background.width = common.STAGE_WIDTH;
		this._background.height = P3.View.height;

		this._earthSprite.position.set(common.STAGE_WIDTH * 0.5 - 200, common.STAGE_HEIGHT - 200);
		this._earthSprite.height = P3.View.height - 200;
		this._earthSprite.scale.x = this._earthSprite.scale.y;

		this._overlay.position.set(this._earthSprite.x - 3, this._earthSprite.y);
		this._overlay.width = this._earthSprite.width * 1.22;
		this._overlay.scale.y = this._overlay.scale.x;

		this._headerLabel.position.set(common.STAGE_WIDTH * 0.5, 25);

		this._carousel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);

		this._backButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 60, 100);

		this._headerBg.width = P3.View.width;
		this._headerBg.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;

		this._headerUnderline.width = P3.View.width;
		this._headerUnderline.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;

		if (this._difficultySelect) {
			this._difficultySelect.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		}
	}

	onCarouselSelected(index) {
		this._stage = SelectScenarioScene.STAGE.DIFFICULTY;

		this._selectedScenario = index + 1;

		this._carousel.visible = false;

		this._difficultySelect = new ScenarioDifficultySelect(this._selectedScenario);
		this._difficultySelect.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._difficultySelect.signals.select.once(this.onDifficultySelect, this);
		this.addChild(this._difficultySelect);
		this.addChild(this._backButton);
	}

	onDifficultySelect(difficulty) {
		this._selectedDifficulty = difficulty;

		common.selectedScenario = this._selectedScenario;
		common.selectedLevel = common.config.scenarios[this._selectedScenario - 1];
		common.difficulty = this._selectedDifficulty;

		common.tracking.track(new P3.TrackingDataGtagEvent('select_level', {
			event_category: 'UI',
			event_type: `select_level_${common.difficulty}`,
			page_container: common.selectedLevel,
		}));

		this.signals.next.dispatch();
	}

	onBackClick() {
		switch (this._stage) {
		case SelectScenarioScene.STAGE.SCENARIO:
			this.signals.previous.dispatch();
			break;
		case SelectScenarioScene.STAGE.DIFFICULTY:
			this._difficultySelect.destroy();
			this._difficultySelect = null;
			this._selectedScenario = null;
			this._carousel.visible = true;

			this._stage = SelectScenarioScene.STAGE.SCENARIO;
			break;
		default:
			break;
		}
	}

	destroy() {
		this._earth.destroy();
		super.destroy();
	}

	renderEarth() {
		if (this._earth && !this._earth.globeDisabled) {
			this._earth.update();
			this._earthSprite.texture.update();
		}
	}

	update() {
		super.update();
		this.renderEarth();
	}
}

SelectScenarioScene.STAGE = {
	SCENARIO: 1,
	DIFFICULTY: 2,
};
